import { createReducer } from '../commons/js/utils/reducer';

const initialState = {
    isLoggedIn: false,
    wasLoggedIn: false,
    role: 0,
    profilePic: '',
    userDetails: {},
    showRolePopup: false
}

const reducer = createReducer(initialState, {
    "SET_LOGGED_IN": (state, action) => {
        let isLoggedIn = action.payload.value;
        let role = isLoggedIn ? action.payload.role : '';

        return {
            ...state,
            isLoggedIn,
            role,
            wasLoggedIn: false
        }
    },
    "SET_PROFILE_PICTURE": (state, action) => {
        let profilePic = action.payload.value
        return {
            ...state,
            profilePic,
        }
    },
    "LOGOUT": (state, action) => {
        return {
            ...initialState,
            wasLoggedIn: true
        }
    },
    "SET_USER_DATA": (state, action) => {
        return {
            ...state,
            userDetails: action.payload.value
        }
    },
    "SET_ROLE_POPUP": (state, action) => {
        return {
            ...state,
            showRolePopup: action.payload.value
        }
    },
})

export default reducer;